import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedUserId:'',
};

const userSlice = createSlice({
    name: "User",
    initialState,
    reducers: {
        setSelectedUserId: (state, action) => {
            state.selectedUserId = action.payload;
        },
        resetSelectedUserId: (state) => {
            state.selectedUserId = '';
        },
    },
});

export const { setSelectedUserId, resetSelectedUserId } = userSlice.actions;

export default userSlice.reducer;
